import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

const ImportLicensePlatesSucceededModal = props => (
    <div id="import-lp-succeeded-modal" className="info-modal panel radius-rectangle">
        <div className="panel-header">
            <h2 className="bold-title">
                <FontAwesomeIcon icon={faCheckCircle} />
                <FormattedMessage id="INFO_MODAL_TITLE_IMPORT_SUCCEEDED" />
            </h2>
            <button className="btn-close-modal" onClick={props.closeModal} />
        </div>
        <div className="panel-content">
            <div className="modal-content align-left">
                <p className="text-light">
                    <FormattedMessage id="INFO_MODAL_BODY_IMPORT_SUCCEEDED" />
                </p>
                <hr className="hr" />
                <p>
                    - <FormattedMessage id="IMPORT_SUCCEEDED_TOTAL_VEHICLES_IMPORTED" />
                    &nbsp;<span className="green bold">{props.validImportRequests.length}</span>
                </p>

                {!!props.invalidImportRequests.length && (
                    <p>
                        - <FormattedMessage id="IMPORT_SUCCEEDED_TOTAL_VEHICLES_NOT_IMPORTED" />
                        &nbsp;<span className="red bold">{props.invalidImportRequests.length}</span>
                    </p>
                )}
            </div>
            <button className="btn-blue" onClick={props.closeModal}>
                <FormattedMessage id="GLOBAL_CLOSE" />
            </button>
        </div>
    </div>
);

export default ImportLicensePlatesSucceededModal;
